import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import {
  BackButton,
  Card,
  CFView,
  DefaultScreen,
  MobileScreen,
  PageBackground,
  PageContainer,
  PageHeader,
  ThemedText,
} from 'components'
import ProductItem from './ProductItem'
import AddQuantityButton from './AddQuantityButton'
import SubtractQuantityButton from './SubtractQuantityButton'
import AddCartButton from './AddCartButton'
import { dispatch } from 'store'

export default ({ location, onRequestClose }) => {
  const history = useHistory()
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const category = dispatch.restaurant.getTakeoutAccessories()
  const [products, setProducts] = useState(
    category.productOrder
      .filter(productId => dispatch.restaurant.getProducts()[productId])
      .map(productId => ({
        ...dispatch.restaurant.getProducts()[productId],
        count: 0,
      }))
  )

  const incrementProductCount = productId => {
    setProducts(products =>
      products.map(product =>
        product.id === productId && product.count < 50
          ? { ...product, count: product.count + 1 }
          : product
      )
    )
  }

  const decrementProductCount = productId => {
    setProducts(products =>
      products.map(product =>
        product.id === productId && product.count > 0
          ? { ...product, count: product.count - 1 }
          : product
      )
    )
  }

  const handleAddToCart = () => {
    const selectedProducts = products.reduce((prev, product) => {
      if (product.count > 0) {
        const { id, count } = product
        prev.push({
          id,
          count,
          choicesPrice: 0,
          choices: [],
        })
      }
      return prev
    }, [])
    if (selectedProducts.length > 0) {
      dispatch.user.addTakeoutAccessoriesToCart(selectedProducts)
    }
    !isMobile && onRequestClose()
    history.push('/cart')
  }

  return (
    <>
      <MobileScreen>
        <PageBackground>
          <PageHeader
            title={category.name}
            LeftButton={<BackButton onClick={history.goBack} />}
          />
          <PageContainer
            offset="header"
            column
            justifyBetween
            pt="20px"
            ph="10px"
          >
            <CFView column>
              {category.description && (
                <Card p="10px" mb="10px">
                  <ThemedText>{category.description}</ThemedText>
                </Card>
              )}
              <Card pt="20px" ph="10px" mb="40px">
                {products.map(product => {
                  return (
                    <ProductItem
                      product={product}
                      AddQuantityButton={
                        <AddQuantityButton
                          onClick={() => incrementProductCount(product.id)}
                        />
                      }
                      SubtractQuantityButton={
                        <SubtractQuantityButton
                          onClick={() => decrementProductCount(product.id)}
                        />
                      }
                    />
                  )
                })}
              </Card>
            </CFView>
            <CFView w="100%" ph="20px" pb="20px">
              <AddCartButton
                onClick={handleAddToCart}
                price={products.reduce(
                  (prev, product) => prev + product.price * product.count,
                  0
                )}
              />
            </CFView>
          </PageContainer>
        </PageBackground>
      </MobileScreen>
      <DefaultScreen>
        <CFView h="500px" w="500px" pt="20px" ph="10px" column justifyBetween>
          <CFView>
            {category.description && (
              <Card p="10px" mb="10px">
                <ThemedText>{category.description}</ThemedText>
              </Card>
            )}
            <Card pt="20px" ph="10px" mb="40px">
              {products.map(product => {
                return (
                  <ProductItem
                    product={product}
                    AddQuantityButton={
                      <AddQuantityButton
                        onClick={() => incrementProductCount(product.id)}
                      />
                    }
                    SubtractQuantityButton={
                      <SubtractQuantityButton
                        onClick={() => decrementProductCount(product.id)}
                      />
                    }
                  />
                )
              })}
            </Card>
          </CFView>
          <CFView w="100%" ph="20px" pb="20px">
            <AddCartButton
              onClick={handleAddToCart}
              price={products.reduce(
                (prev, product) => prev + product.price * product.count,
                0
              )}
            />
          </CFView>
        </CFView>
      </DefaultScreen>
    </>
  )
}
